interface RequestedRoute {
  fullPath?: string;
  hash?: string;
  href?: string;
  matched?: any[];
  meta?: any;
  name?: string | symbol | null;
  params?: any;
  path?: string;
  query?: any;
  redirectedFrom?: any;
}

export const serializeRouteLocation = (route: RequestedRoute): string =>
  JSON.stringify({
    name: typeof route.name === "string" ? route.name : undefined,
    path: route.path,
    query: route.query ? { ...route.query } : undefined,
    params: route.params ? { ...route.params } : undefined,
  });

export const loginExemptPages = [
  "login",
  "forgot-password",
  "register",
  "confirm-verification",
  "confirm-password-reset",
  "account-setup",
];

export const getAuthenticatedAuthPageRedirect = (to: RequestedRoute, userId: string | undefined, userStatus: string | null) => {
  const isOAuthProfileCompletion = to.name === "register"
    && !!to.query?.userId
    && to.query.userId === userId
    && userStatus === "ExtAuth";

  return loginExemptPages.includes(String(to.name)) && !isOAuthProfileCompletion
    ? { name: "index" }
    : null;
};

import { pb } from "@/utils/PocketBaseAdapter";

const AUTH_REFRESH_THROTTLE_MS = 15000;
let lastAuthRefreshAt = 0;
let authRefreshPromise: Promise<void> | null = null;

const shouldValidateAuthNow = () => {
  const now = Date.now();
  return now - lastAuthRefreshAt > AUTH_REFRESH_THROTTLE_MS;
};

const refreshAuthIfNeeded = async () => {
  if (!pb?.authStore?.token) return;

  if (!shouldValidateAuthNow()) return;

  if (authRefreshPromise) {
    await authRefreshPromise;
    return;
  }

  authRefreshPromise = pb.collection("users").authRefresh()
    .then(() => {
      lastAuthRefreshAt = Date.now();
    })
    .finally(() => {
      authRefreshPromise = null;
    });

  await authRefreshPromise;
};

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// import { pb } from "@/utils/PocketBaseAdapter";
// export const isUserLoggedIn = async (to: RequestedRoute) => {
//   try {
//     if (pb?.authStore?.isValid) {
//       await pb.collection("users").authRefresh();
//     }
//     const isValid =
//       pb.authStore?.isValid &&
//       pb.authStore["baseModel"]?.firstName &&
//       pb.authStore["baseModel"]?.lastName &&
//       pb.authStore["baseModel"]?.homeLocation;
//     const status = pb?.authStore["baseModel"]?.status;
//     return { isLoggedIn: isValid, userStatus: status };
//   } catch (error) {
//     pb.authStore.clear();
//     sessionStorage.setItem("userOnWayTo", JSON.stringify(to));
//     return { isLoggedIn: false, userStatus: null };
//   }
// };

export const isUserLoggedIn = async (to: RequestedRoute) => {
  try {
    const hasToken = !!`${pb?.authStore?.token || ""}`.trim();
    if (!hasToken) {
      return { isLoggedIn: false, userStatus: null };
    }

    await refreshAuthIfNeeded();

    const authStore: any = pb?.authStore;
    const authModel = authStore?.record || authStore?.model || authStore?.baseModel || null;
    const status = authModel?.status || null;
    const isValid = !!authStore?.isValid && !!`${authStore?.token || ""}`.trim();

    return { isLoggedIn: isValid, userStatus: status };
  } catch (error) {
    pb.authStore.clear();

    if (to?.name !== "logout" && to?.path !== "/logout") {
      sessionStorage.setItem("userOnWayTo", serializeRouteLocation(to));
    }

    return { isLoggedIn: false, userStatus: null };
  }
};
